import script from "./MyFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyFooter.vue?vue&type=script&lang=ts&setup=true"

import "./MyFooter.vue?vue&type=style&index=0&id=42b2e73e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42b2e73e"]])

export default __exports__